import React from 'react';
import { observer } from 'mobx-react-lite';
import Loading from 'src/components/Loading/Loading';
import { LoginForm } from 'src/components/LoginForm/LoginForm';
import { LoginPageWrapper, LoginBoxWrapper, LoginBox, LoginHeader, LoginText } from './LoginPage.style';
import { useAppStateContext } from 'src/AppState/AppState';
import { LoginPageLogo } from './LoginPageLogo';
import { getTranslationFor } from 'src/locale/lang';
import { LoginImageContainer } from './LoginImage';

export const LoginPage = observer(() => {
    const { reduxLoginState } = useAppStateContext();

    return (
        <LoginPageWrapper data-test='login-page-wrapper'>
            <LoginImageContainer />
            <LoginBoxWrapper>
                <LoginBox>
                    <LoginPageLogo />
                    <LoginHeader data-test='login-header'>{getTranslationFor('LOGIN_HEADER')}</LoginHeader>
                    <LoginText data-test='login-text'>{getTranslationFor('LOGIN_SUBTITLE')}</LoginText>
                    <LoginForm />
                </LoginBox>
            </LoginBoxWrapper>
            <Loading
                active={reduxLoginState.loginStatus === 'IN_PROGRESS'}
                message='Logging into user...'
            />
        </LoginPageWrapper>
    );
});
